export const Bootstrap4Classes = [
  {
    category: 'Navbar',
    description: 'Adds a white text color to the active link in a navbar.',
    enable: true,
    key: 'active',
    name: 'Active',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Creates an alert message box',
    enable: true,
    key: 'alert',
    name: 'Alert',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Red alert. Indicates a dangerous or potentially negative action',
    enable: true,
    key: 'alert-danger',
    name: 'Alert Danger',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Dark alert. Dark grey alert box',
    enable: true,
    key: 'alert-dark',
    name: 'Alert Dark',
    type: 'text',
  },
  {
    category: 'Alerts',
    description:
      'Indicates a closable alert box. Together with the .close class, this class is used to close the alert (adds extra padding)',
    enable: true,
    key: 'alert-dismissible',
    name: 'Alert Dismissible',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Adds color:inherit to the specified element',
    enable: true,
    key: 'alert-heading',
    name: 'Alert Heading',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Teal alert. Indicates a neutral informative change or action',
    enable: true,
    key: 'alert-info',
    name: 'Alert Info',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Light alert. Light grey alert box',
    enable: true,
    key: 'alert-light',
    name: 'Alert Light',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Used on links inside alerts to provide matching colored links',
    enable: true,
    key: 'alert-link',
    name: 'Alert Link',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Blue alert. Indicates an important action',
    enable: true,
    key: 'alert-primary',
    name: 'Alert Primary',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Grey alert. Indicates a &quot;less&quot; important action',
    enable: true,
    key: 'alert-secondary',
    name: 'Alert Secondary',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Green alert. Indicates a successful or positive action',
    enable: true,
    key: 'alert-success',
    name: 'Alert Success',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Yellow alert. Indicates caution should be taken with this action',
    enable: true,
    key: 'alert-warning',
    name: 'Alert Warning',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Creates a circular badge (grey circle - often used as a numerical indicator)',
    enable: true,
    key: 'badge',
    name: 'Badge',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Red badge. Indicates a dangerous or potentially negative action',
    enable: true,
    key: 'badge-danger',
    name: 'Badge Danger',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Dark badge. Dark grey alert box',
    enable: true,
    key: 'badge-dark',
    name: 'Badge Dark',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Teal badge. Indicates a neutral informative change or action',
    enable: true,
    key: 'badge-info',
    name: 'Badge Info',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Light badge. Light grey alert box',
    enable: true,
    key: 'badge-light',
    name: 'Badge Light',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Makes a badge more round',
    enable: true,
    key: 'badge-pill',
    name: 'Badge Pill',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Blue badge. Indicates an important action',
    enable: true,
    key: 'badge-primary',
    name: 'Badge Primary',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Grey badge. Indicates a &quot;less&quot; important action',
    enable: true,
    key: 'badge-secondary',
    name: 'Badge Secondary',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Green badge. Indicates a successful or positive action',
    enable: true,
    key: 'badge-success',
    name: 'Badge Success',
    type: 'text',
  },
  {
    category: 'Badges',
    description: 'Yellow badge. Indicates caution should be taken with this action',
    enable: true,
    key: 'badge-warning',
    name: 'Badge Warning',
    type: 'text',
  },
  {
    category: 'Colors',
    description:
      'Adds a red background color to an element. Represents danger or a negative action',
    enable: true,
    key: 'bg-danger',
    name: 'Bg Danger',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Adds a dark grey background color to an element',
    enable: true,
    key: 'bg-dark',
    name: 'Bg Dark',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Adds a teal background color to an element. Represents some information',
    enable: true,
    key: 'bg-info',
    name: 'Bg Info',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Adds a light grey background color to an element',
    enable: true,
    key: 'bg-light',
    name: 'Bg Light',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Adds a blue background color to an element. Represents something important',
    enable: true,
    key: 'bg-primary',
    name: 'Bg Primary',
    type: 'text',
  },
  {
    category: 'Colors',
    description:
      'Adds a grey background color to an element. Indicates a &quot;less&quot; important action',
    enable: true,
    key: 'bg-secondary',
    name: 'Bg Secondary',
    type: 'text',
  },
  {
    category: 'Colors',
    description:
      'Adds a green background color to an element. Indicates success or a positive action',
    enable: true,
    key: 'bg-success',
    name: 'Bg Success',
    type: 'text',
  },
  {
    category: 'Colors',
    description:
      'Adds a yellow/orange background color to an element. Represents a warning or a negative action',
    enable: true,
    key: 'bg-warning',
    name: 'Bg Warning',
    type: 'text',
  },
  {
    category: 'Typography',
    description:
      'Styles quoted blocks of content from another source (adds a larger font-size (1.25rem))',
    enable: true,
    key: 'blockquote',
    name: 'Blockquote',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Styles the source title inside the blockquote (light grey text with indentation)',
    enable: true,
    key: 'blockquote-footer',
    name: 'Blockquote Footer',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a border to an element',
    enable: true,
    key: 'border',
    name: 'Border',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Removes the bottom border from an element',
    enable: true,
    key: 'border-bottom-0',
    name: 'Border Bottom 0',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a red border to an element (indicates danger)',
    enable: true,
    key: 'border-danger',
    name: 'Border Danger',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a dark border to an element',
    enable: true,
    key: 'border-dark',
    name: 'Border Dark',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a teal border to an element (indicates information)',
    enable: true,
    key: 'border-info',
    name: 'Border Info',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Removes the left border from an element',
    enable: true,
    key: 'border-left-0',
    name: 'Border Left 0',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a light grey border to an element',
    enable: true,
    key: 'border-light',
    name: 'Border Light',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a blue border to an element',
    enable: true,
    key: 'border-primary',
    name: 'Border Primary',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Removes the right border from an element',
    enable: true,
    key: 'border-right-0',
    name: 'Border Right 0',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Removes the top border from an element',
    enable: true,
    key: 'border-top-0',
    name: 'Border Top 0',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a grey border to an element',
    enable: true,
    key: 'border-secondary',
    name: 'Border Secondary',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a green border to an element (indicates success)',
    enable: true,
    key: 'border-success',
    name: 'Border Success',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a orange border to an element (indicates warning)',
    enable: true,
    key: 'border-warning',
    name: 'Border Warning',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a white border to an element',
    enable: true,
    key: 'border-white',
    name: 'Border White',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Removes all borders from an element',
    enable: true,
    key: 'border-0',
    name: 'Border 0',
    type: 'text',
  },
  {
    category: 'Pagination',
    description:
      "A pagination. Indicates the current page's location within a navigational hierarchy",
    enable: true,
    key: 'breadcrumb',
    name: 'Breadcrumb',
    type: 'text',
  },
  {
    category: 'Pagination',
    description: 'Styles list items or links inside the breadcrumb',
    enable: true,
    key: 'breadcrumb-item',
    name: 'Breadcrumb Item',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Creates a basic button (gray background and rounded corners)',
    enable: true,
    key: 'btn',
    name: 'Btn',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Creates a block level button that spans the entire width of the parent element',
    enable: true,
    key: 'btn-block',
    name: 'Btn Block',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Dark grey button',
    enable: true,
    key: 'btn-dark',
    name: 'Btn Dark',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Red button. Indicates danger or a negative action',
    enable: true,
    key: 'btn-danger',
    name: 'Btn Danger',
    type: 'text',
  },
  {
    category: 'Button Groups',
    description: 'Groups buttons together on a single line',
    enable: true,
    key: 'btn-group',
    name: 'Btn Group',
    type: 'text',
  },
  {
    category: 'Button Groups',
    description:
      'Large button group (makes all buttons in a button group larger - increased font-size and padding)',
    enable: true,
    key: 'btn-group-lg',
    name: 'Btn Group Lg',
    type: 'text',
  },
  {
    category: 'Button Groups',
    description: 'Small button group (makes all buttons in a button group smaller)',
    enable: true,
    key: 'btn-group-sm',
    name: 'Btn Group Sm',
    type: 'text',
  },
  {
    category: 'Button Groups',
    description: 'Makes a button group appear vertically stacked',
    enable: true,
    key: 'btn-group-vertical',
    name: 'Btn Group Vertical',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Teal button. Represents a neutral informative change or action',
    enable: true,
    key: 'btn-info',
    name: 'Btn Info',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Light grey button',
    enable: true,
    key: 'btn-light',
    name: 'Btn Light',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Makes a button look like a link (get button behavior)',
    enable: true,
    key: 'btn-link',
    name: 'Btn Link',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Large button',
    enable: true,
    key: 'btn-lg',
    name: 'Btn Lg',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Dark grey bordered/outlined button',
    enable: true,
    key: 'btn-outline-dark',
    name: 'Btn Outline Dark',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Red bordered/outlined button. Indicates danger or a negative action',
    enable: true,
    key: 'btn-outline-danger',
    name: 'Btn Outline Danger',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Teal bordered/outlined button. Represents a neutral informative change or action',
    enable: true,
    key: 'btn-outline-info',
    name: 'Btn Outline Info',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Light grey bordered/outlined button',
    enable: true,
    key: 'btn-outline-light',
    name: 'Btn Outline Light',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Blue bordered/outlined button.',
    enable: true,
    key: 'btn-outline-primary',
    name: 'Btn Outline Primary',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Grey bordered/outlined button. Indicates a &quot;less&quot; important action',
    enable: true,
    key: 'btn-outline-secondary',
    name: 'Btn Outline Secondary',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Green bordered/outlined button. Indicates success or a positive action',
    enable: true,
    key: 'btn-outline-success',
    name: 'Btn Outline Success',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Orange bordered/outlined button. Represents warning or a negative action',
    enable: true,
    key: 'btn-outline-warning',
    name: 'Btn Outline Warning',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Blue button. Indicates a something important',
    enable: true,
    key: 'btn-primary',
    name: 'Btn Primary',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Small button',
    enable: true,
    key: 'btn-sm',
    name: 'Btn Sm',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Grey button. Indicates a &quot;less&quot; important action',
    enable: true,
    key: 'btn-secondary',
    name: 'Btn Secondary',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Green button. Indicates success or a positive action',
    enable: true,
    key: 'btn-success',
    name: 'Btn Success',
    type: 'text',
  },
  {
    category: 'Button Groups',
    description: 'Combine sets of button groups into button toolbars for more complex components',
    enable: true,
    key: 'btn-toolbar',
    name: 'Btn Toolbar',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Orange button. Represents warning or a negative action',
    enable: true,
    key: 'btn-warning',
    name: 'Btn Warning',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Creates a card',
    enable: true,
    key: 'card',
    name: 'Card',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Container for card content',
    enable: true,
    key: 'card-body',
    name: 'Card Body',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Container to create a masonry-like grid of cards',
    enable: true,
    key: 'card-columns',
    name: 'Card Columns',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Adds a red background color to the card. Represents danger or a negative action',
    enable: true,
    key: 'card-danger',
    name: 'Card Danger',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Adds a grey background color to the card',
    enable: true,
    key: 'card-dark',
    name: 'Card Dark',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Container to create a grid of cards that are of equal height and width',
    enable: true,
    key: 'card-deck',
    name: 'Card Deck',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Card footer',
    enable: true,
    key: 'card-footer',
    name: 'Card Footer',
    type: 'text',
  },
  {
    category: 'Cards',
    description:
      'Container to create a grid of cards that are of equal height and width, without side margins',
    enable: true,
    key: 'card-group',
    name: 'Card Group',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Card header',
    enable: true,
    key: 'card-header',
    name: 'Card Header',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Styles navigation tabs inside the card header',
    enable: true,
    key: 'card-header-tabs',
    name: 'Card Header Tabs',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Styles navigation pills inside the card header',
    enable: true,
    key: 'card-header-pills',
    name: 'Card Header Pills',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Place the image at the bottom inside a card',
    enable: true,
    key: 'card-img-bottom',
    name: 'Card Img Bottom',
    type: 'text',
  },
  {
    category: 'Cards',
    description:
      'Turns an image into a card background. Often used to add text on top of the image',
    enable: true,
    key: 'card-img-overlay',
    name: 'Card Img Overlay',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Place the image at the top inside a card',
    enable: true,
    key: 'card-img-top',
    name: 'Card Img Top',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Adds a teal background color to the card. Represents some information',
    enable: true,
    key: 'card-info',
    name: 'Card Info',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Adds a light grey background color to the card',
    enable: true,
    key: 'card-light',
    name: 'Card Light',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Adds a blue color to any link and a hover effect inside the card',
    enable: true,
    key: 'card-link',
    name: 'Card Link',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Adds a blue background color to the card. Represents something important',
    enable: true,
    key: 'card-primary',
    name: 'Card Primary',
    type: 'text',
  },
  {
    category: 'Cards',
    description:
      'Adds a grey background color to the card. Represents something &quot;less&quot; important',
    enable: true,
    key: 'card-secondary',
    name: 'Card Secondary',
    type: 'text',
  },
  {
    category: 'Cards',
    description:
      'The .card-subtitle is used after a .card-title, and adds the following to an element: margin-top: -.375rem; margin-bottom: 0;',
    enable: true,
    key: 'card-subtitle',
    name: 'Card Subtitle',
    type: 'text',
  },
  {
    category: 'Cards',
    description:
      'Adds a green background color to the card. Indicates success or a positive action',
    enable: true,
    key: 'card-success',
    name: 'Card Success',
    type: 'text',
  },
  {
    category: 'Cards',
    description:
      'Used to remove bottom margins for a p element if it is the last child (or the only one), inside .card-body',
    enable: true,
    key: 'card-text',
    name: 'Card Text',
    type: 'text',
  },
  {
    category: 'Cards',
    description: 'Adds a title to any heading element inside the card',
    enable: true,
    key: 'card-title',
    name: 'Card Title',
    type: 'text',
  },
  {
    category: 'Cards',
    description:
      'Adds a yellow/orange background color to the card. Represents a warning or a negative action',
    enable: true,
    key: 'card-warning',
    name: 'Card Warning',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Clears floats',
    enable: true,
    key: 'clearfix',
    name: 'Clearfix',
    type: 'text',
  },
  {
    category: 'Utilities',
    description:
      'Styles a close icon. This is often used for alerts and modals. Often used together with the &amp;times; symbol to create the actual icon (a better looking &quot;x&quot;). It floats right by default',
    enable: true,
    key: 'close',
    name: 'Close',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Make form columns automatically size themselves based on their content',
    enable: true,
    key: 'col-auto',
    name: 'Col Auto',
    type: 'text',
  },
  {
    category: 'Containers',
    description:
      'Fixed width container with widths determined by screen sites. Equal margin on the left and right.',
    enable: true,
    key: 'container',
    name: 'Container',
    type: 'text',
  },
  {
    category: 'Containers',
    description: 'A container that spans the full width of the screen',
    enable: true,
    key: 'container-fluid',
    name: 'Container Fluid',
    type: 'text',
  },
  {
    category: 'Buttons',
    description: 'Disables a button (adds opacity and a &quot;no-parking-sign&quot; icon on hover)',
    enable: true,
    key: 'disabled',
    name: 'Disabled',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description:
      'Creates a toggleable menu that allows the user to choose one value from a predefined list',
    enable: true,
    key: 'dropdown',
    name: 'Dropdown',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Used to separate links in the dropdown menu with a thin horizontal border',
    enable: true,
    key: 'dropdown-divider',
    name: 'Dropdown Divider',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Used to add headers inside the dropdown menu',
    enable: true,
    key: 'dropdown-header',
    name: 'Dropdown Header',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Creates a dropdown item (added to links or buttons inside .dropdown-menu)',
    enable: true,
    key: 'dropdown-item',
    name: 'Dropdown Item',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description:
      'Used to add plain text to a dropdown item, or used on links for default link styling',
    enable: true,
    key: 'dropdown-item-text',
    name: 'Dropdown Item Text',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Adds the default styles for the dropdown menu container',
    enable: true,
    key: 'dropdown-menu',
    name: 'Dropdown Menu',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Right-aligns a dropdown menu',
    enable: true,
    key: 'dropdown-menu-right',
    name: 'Dropdown Menu Right',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Used on the button that should hide and show (toggle) the dropdown menu',
    enable: true,
    key: 'dropdown-toggle',
    name: 'Dropdown Toggle',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Left-aligns the dropdown',
    enable: true,
    key: 'dropleft',
    name: 'Dropleft',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Right-aligns the dropdown',
    enable: true,
    key: 'dropright',
    name: 'Dropright',
    type: 'text',
  },
  {
    category: 'Dropdowns',
    description: 'Indicates a dropup menu (upwards instead of downwards)',
    enable: true,
    key: 'dropup',
    name: 'Dropup',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Creates a block element (adds display:block)',
    enable: true,
    key: 'd-block',
    name: 'D Block',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Makes an element inline',
    enable: true,
    key: 'd-inline',
    name: 'D Inline',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Makes an element inline block',
    enable: true,
    key: 'd-inline-block',
    name: 'D Inline Block',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Creates a flexbox container and transforms direct children into flex items',
    enable: true,
    key: 'd-flex',
    name: 'D Flex',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Creates an inline flexbox container',
    enable: true,
    key: 'd-inline-flex',
    name: 'D Inline Flex',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Hides an element',
    enable: true,
    key: 'd-none',
    name: 'D None',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Makes an element display as a table',
    enable: true,
    key: 'd-table',
    name: 'D Table',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Makes an element display as a table cell',
    enable: true,
    key: 'd-table-cell',
    name: 'D Table Cell',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Makes an element display as a table row',
    enable: true,
    key: 'd-table-row',
    name: 'D Table Row',
    type: 'text',
  },
  {
    category: 'Images',
    description:
      'Container for embedded content. Makes videos or slideshows scale properly on any device',
    enable: true,
    key: 'embed-responsive',
    name: 'Embed Responsive',
    type: 'text',
  },
  {
    category: 'Images',
    description: 'Container for embedded content. Creates an 16:9 aspect ratio embedded content',
    enable: true,
    key: 'embed-responsive-16by9',
    name: 'Embed Responsive 16by9',
    type: 'text',
  },
  {
    category: 'Images',
    description: 'Container for embedded content. Creates an 3:4 aspect ratio embedded content',
    enable: true,
    key: 'embed-responsive-3by4',
    name: 'Embed Responsive 3by4',
    type: 'text',
  },
  {
    category: 'Images',
    description: 'Used inside .embed-responsive. Scales the video nicely to the parent element',
    enable: true,
    key: 'embed-responsive-item',
    name: 'Embed Responsive Item',
    type: 'text',
  },
  {
    category: 'Alerts',
    description: 'Adds a fading effect when closing an alert box',
    enable: true,
    key: 'fade',
    name: 'Fade',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Makes an element stay at the bottom of the screen (sticky/fixed)',
    enable: true,
    key: 'fixed-bottom',
    name: 'Fixed Bottom',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Makes an element stay at the top of the screen (sticky/fixed)',
    enable: true,
    key: 'fixed-top',
    name: 'Fixed Top',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Display flex items vertically',
    enable: true,
    key: 'flex-column',
    name: 'Flex Column',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Display flex items vertically, reversed',
    enable: true,
    key: 'flex-column-reverse',
    name: 'Flex Column Reverse',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Used on flex items to force it/them into equal width columns',
    enable: true,
    key: 'flex-fill',
    name: 'Flex Fill',
    type: 'text',
  },
  {
    category: 'Flex',
    description: "Don't wrap flex items",
    enable: true,
    key: 'flex-nowrap',
    name: 'Flex Nowrap',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Display flex items horizontally (side by side)',
    enable: true,
    key: 'flex-row',
    name: 'Flex Row',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Display flex items right-aligned and horizontally',
    enable: true,
    key: 'flex-row-reverse',
    name: 'Flex Row Reverse',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Wrap flex items',
    enable: true,
    key: 'flex-wrap',
    name: 'Flex Wrap',
    type: 'text',
  },
  {
    category: 'Flex',
    description: 'Wrap flex items, in reversed order',
    enable: true,
    key: 'flex-wrap-reverse',
    name: 'Flex Wrap Reverse',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Floats an element to the left',
    enable: true,
    key: 'float-left',
    name: 'Float Left',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Remove floats from an element',
    enable: true,
    key: 'float-none',
    name: 'Float None',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Floats an element to the right',
    enable: true,
    key: 'float-right',
    name: 'Float Right',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Italic text',
    enable: true,
    key: 'font-italic',
    name: 'Font Italic',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Bold text',
    enable: true,
    key: 'font-weight-bold',
    name: 'Font Weight Bold',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Bolder text (font-weight:bolder)',
    enable: true,
    key: 'font-weight-bolder',
    name: 'Font Weight Bolder',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Light weight text (font-weight:300)',
    enable: true,
    key: 'font-weight-light',
    name: 'Font Weight Light',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Lighter weight text (font-weight:lighter)',
    enable: true,
    key: 'font-weight-lighter',
    name: 'Font Weight Lighter',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Normal text (font-weight:400)',
    enable: true,
    key: 'font-weight-normal',
    name: 'Font Weight Normal',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Container for checkboxes. Adds proper padding',
    enable: true,
    key: 'form-check',
    name: 'Form Check',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Makes checkboxes appear on the same line (horizontally)',
    enable: true,
    key: 'form-check-inline',
    name: 'Form Check Inline',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Styles checkboxes with proper margins',
    enable: true,
    key: 'form-check-input',
    name: 'Form Check Input',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Ensures proper margins for labels used together with checkboxes',
    enable: true,
    key: 'form-check-label',
    name: 'Form Check Label',
    type: 'text',
  },
  {
    category: 'Forms',
    description:
      'Used on input, textarea, and select elements to span the entire width of the page and make them responsive',
    enable: true,
    key: 'form-control',
    name: 'Form Control',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Adds display:block and width:100% to input filed with type=&quot;file',
    enable: true,
    key: 'form-control-file',
    name: 'Form Control File',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Large form control',
    enable: true,
    key: 'form-control-lg',
    name: 'Form Control Lg',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Styles a form control as plain text',
    enable: true,
    key: 'form-control-plaintext',
    name: 'Form Control Plaintext',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Adds display:block and width:100% to input filed with type=&quot;range',
    enable: true,
    key: 'form-control-range',
    name: 'Form Control Range',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Small form control',
    enable: true,
    key: 'form-control-sm',
    name: 'Form Control Sm',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Container for form input and label',
    enable: true,
    key: 'form-group',
    name: 'Form Group',
    type: 'text',
  },
  {
    category: 'Forms',
    description:
      'Makes a &lt;form&gt; left-aligned with inline-block controls (This only applies to forms within viewports that are at least 768px wide)',
    enable: true,
    key: 'form-inline',
    name: 'Form Inline',
    type: 'text',
  },
  {
    category: 'Forms',
    description:
      'Container for responsive columns (less left and right margins than .row/overrides default column gutters)',
    enable: true,
    key: 'form-row',
    name: 'Form Row',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the height of an element to 25%',
    enable: true,
    key: 'h-25',
    name: 'H 25',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the height of an element to 50%',
    enable: true,
    key: 'h-50',
    name: 'H 50',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the height of an element to 75%',
    enable: true,
    key: 'h-75',
    name: 'H 75',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the height of an element to 100%',
    enable: true,
    key: 'h-100',
    name: 'H 100',
    type: 'text',
  },
  {
    category: 'Images',
    description: 'Responsive image (adds max-width:100% and height:auto)',
    enable: true,
    key: 'img-fluid',
    name: 'Img Fluid',
    type: 'text',
  },
  {
    category: 'Images',
    description: 'Shapes an image to a thumbnail (thin light grey borders)',
    enable: true,
    key: 'img-thumbnail',
    name: 'Img Thumbnail',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Displays the text inside an &lt;abbr&gt; element in a slightly smaller font size',
    enable: true,
    key: 'initialism',
    name: 'Initialism',
    type: 'text',
  },
  {
    category: 'Input Sizing',
    description: 'Large input field',
    enable: true,
    key: 'input-lg',
    name: 'Input Lg',
    type: 'text',
  },
  {
    category: 'Input Sizing',
    description: 'Small input field',
    enable: true,
    key: 'input-sm',
    name: 'Input Sm',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Creates a custom validation message used in validated forms (red text color)',
    enable: true,
    key: 'invalid-feedback',
    name: 'Invalid Feedback',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Creates a custom validation message used in validated forms (red tooltip)',
    enable: true,
    key: 'invalid-tooltip',
    name: 'Invalid Tooltip',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Make an element invisible',
    enable: true,
    key: 'invisible',
    name: 'Invisible',
    type: 'text',
  },
  {
    category: 'Forms',
    description:
      'Validates a form element (adds a red border to input fields). Note: for server side',
    enable: true,
    key: 'is-invalid',
    name: 'Is Invalid',
    type: 'text',
  },
  {
    category: 'Forms',
    description:
      'Validates a form element (adds a green border to input fields). Note: for server side',
    enable: true,
    key: 'is-valid',
    name: 'Is Valid',
    type: 'text',
  },
  {
    category: 'Jumbotron',
    description:
      'Creates a padded grey heading/box with rounded corners that enlarges the font sizes of the text inside it. Used for calling extra attention to some special content or information',
    enable: true,
    key: 'jumbotron',
    name: 'Jumbotron',
    type: 'text',
  },
  {
    category: 'Jumbotron',
    description: 'Creates a full-width jumbotron (grey padded heading) without rounded borders',
    enable: true,
    key: 'jumbotron-fluid',
    name: 'Jumbotron Fluid',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Increase the font size and line height of a paragraph',
    enable: true,
    key: 'lead',
    name: 'Lead',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Creates a bordered list group for &lt;li&gt; elements',
    enable: true,
    key: 'list-group',
    name: 'List Group',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Removes some borders and rounded corners from list items in a list group',
    enable: true,
    key: 'list-group-flush',
    name: 'List Group Flush',
    type: 'text',
  },
  {
    category: 'List Group',
    description:
      'Display list items horizontally instead of vertically (side-by-side instead of on top of each other)',
    enable: true,
    key: 'list-group-horizontal',
    name: 'List Group Horizontal',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Added to each &lt;li&gt; element in the list group',
    enable: true,
    key: 'list-group-item',
    name: 'List Group Item',
    type: 'text',
  },
  {
    category: 'List Group',
    description:
      'Added to links inside the list group to make them stand out on hover (darker background)',
    enable: true,
    key: 'list-group-item-action',
    name: 'List Group Item Action',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Red background color for a list item in a list group',
    enable: true,
    key: 'list-group-item-danger',
    name: 'List Group Item Danger',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Dark grey background color for a list item in a list group',
    enable: true,
    key: 'list-group-item-dark',
    name: 'List Group Item Dark',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Light-blue background color for a list item in a list group',
    enable: true,
    key: 'list-group-item-info',
    name: 'List Group Item Info',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Light grey background color for a list item in a list group',
    enable: true,
    key: 'list-group-item-light',
    name: 'List Group Item Light',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Blue background color for a list item in a list group',
    enable: true,
    key: 'list-group-item-primary',
    name: 'List Group Item Primary',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Green background color for a list item in a list group',
    enable: true,
    key: 'list-group-item-success',
    name: 'List Group Item Success',
    type: 'text',
  },
  {
    category: 'List Group',
    description: 'Yellow background color for a list item in a list group',
    enable: true,
    key: 'list-group-item-warning',
    name: 'List Group Item Warning',
    type: 'text',
  },
  {
    category: 'Typography',
    description:
      'Places all list items on a single line (used together with .list-inline-item on each &lt;li&gt; elements)',
    enable: true,
    key: 'list-inline',
    name: 'List Inline',
    type: 'text',
  },
  {
    category: 'Typography',
    description:
      'Places all list items on a single line (used together with .list-inline on the parent &lt;ul&gt; element)',
    enable: true,
    key: 'list-inline-item',
    name: 'List Inline Item',
    type: 'text',
  },
  {
    category: 'Typography',
    description:
      'Removes all default list-style (bullets, left margin, etc.) styling from a &lt;ul&gt; or &lt;ol&gt; list',
    enable: true,
    key: 'list-unstyled',
    name: 'List Unstyled',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Highlights text: Highlighted text',
    enable: true,
    key: 'mark',
    name: 'Mark',
    type: 'text',
  },
  {
    category: 'Media Objects',
    description:
      'Aligns media objects together with content (like images or videos - often used for comments in a blog post etc)',
    enable: true,
    key: 'media',
    name: 'Media',
    type: 'text',
  },
  {
    category: 'Media Objects',
    description: 'Container for media content',
    enable: true,
    key: 'media-body',
    name: 'Media Body',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Centers an element horizontally',
    enable: true,
    key: 'mx-auto',
    name: 'Mx Auto',
    type: 'text',
  },
  {
    category: 'Tabs',
    description: 'Creates a tabbed menu',
    enable: true,
    key: 'nav nav-tabs',
    name: 'Nav Nav Tabs',
    type: 'text',
  },
  {
    category: 'Tabs',
    description: 'Creates a pill menu',
    enable: true,
    key: 'nav nav-pills',
    name: 'Nav Nav Pills',
    type: 'text',
  },
  {
    category: 'Tabs',
    description: 'Justifies tab/pill links with an equal width',
    enable: true,
    key: 'nav-justified',
    name: 'Nav Justified',
    type: 'text',
  },
  {
    category: 'Navbar',
    description: 'Creates a navigation bar',
    enable: true,
    key: 'navbar',
    name: 'Navbar',
    type: 'text',
  },
  {
    category: 'Navbar',
    description: 'Container for navigation links inside the .navbar container',
    enable: true,
    key: 'navbar-nav',
    name: 'Navbar Nav',
    type: 'text',
  },
  {
    category: 'Navbar',
    description:
      'Added to a link or a header element inside the navbar to represent a logo or a header',
    enable: true,
    key: 'navbar-brand',
    name: 'Navbar Brand',
    type: 'text',
  },
  {
    category: 'Navbar',
    description:
      'Collapses the navbar (hidden and replaced with a menu/hamburger icon on mobile phones and small tablets)',
    enable: true,
    key: 'navbar-collapse',
    name: 'Navbar Collapse',
    type: 'text',
  },
  {
    category: 'Navbar',
    description: 'Adds a white text color to all links in the navbar',
    enable: true,
    key: 'navbar-dark',
    name: 'Navbar Dark',
    type: 'text',
  },
  {
    category: 'Navbar',
    description: 'Adds a black text color to all links in the navbar',
    enable: true,
    key: 'navbar-light',
    name: 'Navbar Light',
    type: 'text',
  },
  {
    category: 'Navbar',
    description:
      'Vertically align any elements inside the navbar that are not links (ensures proper padding)',
    enable: true,
    key: 'navbar-text',
    name: 'Navbar Text',
    type: 'text',
  },
  {
    category: 'Navbar',
    description:
      'Styles the button that should open the navbar on small screens. Automatically styled as a hamburger/three bars',
    enable: true,
    key: 'navbar-toggler',
    name: 'Navbar Toggler',
    type: 'text',
  },
  {
    category: 'Navbar',
    description: 'Used to style links/anchors inside the navbar',
    enable: true,
    key: 'nav-link',
    name: 'Nav Link',
    type: 'text',
  },
  {
    category: 'Navbar',
    description: 'Used to style list items inside the navbar',
    enable: true,
    key: 'nav-item',
    name: 'Nav Item',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Adds validation styles to a submitted form',
    enable: true,
    key: 'needs-validation',
    name: 'Needs Validation',
    type: 'text',
  },
  {
    category: 'Grid System',
    description: 'Remove gutters/extra space from columns',
    enable: true,
    key: 'no-gutters',
    name: 'No Gutters',
    type: 'text',
  },
  {
    category: 'Helpers',
    description:
      'Makes a &lt;pre&gt; element scrollable (max-height of 350px and provide a y-axis scrollbar)',
    enable: true,
    key: 'pre-scrollable',
    name: 'Pre Scrollable',
    type: 'text',
  },
  {
    category: 'Progress Bars',
    description: 'Container for progress bars',
    enable: true,
    key: 'progress',
    name: 'Progress',
    type: 'text',
  },
  {
    category: 'Progress Bars',
    description: 'Creates a progress bar',
    enable: true,
    key: 'progress-bar',
    name: 'Progress Bar',
    type: 'text',
  },
  {
    category: 'Progress Bars',
    description: 'Animates the progress bar (used together with stripes)',
    enable: true,
    key: 'progress-bar-animated',
    name: 'Progress Bar Animated',
    type: 'text',
  },
  {
    category: 'Progress Bars',
    description: 'Adds stripes to the progress bar',
    enable: true,
    key: 'progress-bar-striped',
    name: 'Progress Bar Striped',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds rounded corners to an element',
    enable: true,
    key: 'rounded',
    name: 'Rounded',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds bottom rounded corners to an element',
    enable: true,
    key: 'rounded-bottom',
    name: 'Rounded Bottom',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Shapes an element to a circle (not supported in IE8 and earlier)',
    enable: true,
    key: 'rounded-circle',
    name: 'Rounded Circle',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds left rounded corners of an element',
    enable: true,
    key: 'rounded-left',
    name: 'Rounded Left',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds right rounded corners to an element',
    enable: true,
    key: 'rounded-right',
    name: 'Rounded Right',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds top rounded corners to an element',
    enable: true,
    key: 'rounded-top',
    name: 'Rounded Top',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Removes rounded corners from an element',
    enable: true,
    key: 'rounded-0',
    name: 'Rounded 0',
    type: 'text',
  },
  {
    category: 'Grid System',
    description: 'Container for responsive columns',
    enable: true,
    key: 'row',
    name: 'Row',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a shadow to an element',
    enable: true,
    key: 'shadow',
    name: 'Shadow',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a large shadow to an element',
    enable: true,
    key: 'shadow-lg',
    name: 'Shadow Lg',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Removes shadows from an element',
    enable: true,
    key: 'shadow-none',
    name: 'Shadow None',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Adds a small shadow to an element',
    enable: true,
    key: 'shadow-sm',
    name: 'Shadow Sm',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Creates a lighter, secondary text in any heading',
    enable: true,
    key: 'small',
    name: 'Small',
    type: 'text',
  },
  {
    category: 'Spinners',
    description: 'Creates a spinner/loader',
    enable: true,
    key: 'spinner-border',
    name: 'Spinner Border',
    type: 'text',
  },
  {
    category: 'Spinners',
    description: 'Creates a smaller spinner/loader',
    enable: true,
    key: 'spinner-border-sm',
    name: 'Spinner Border Sm',
    type: 'text',
  },
  {
    category: 'Spinners',
    description: 'Creates a spinner/loader that &quot;grows',
    enable: true,
    key: 'spinner-grow',
    name: 'Spinner Grow',
    type: 'text',
  },
  {
    category: 'Spinners',
    description: 'Creates a smaller spinner/loader that &quot;grows',
    enable: true,
    key: 'spinner-grow-sm',
    name: 'Spinner Grow Sm',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Hides an element on all devices except for screen readers',
    enable: true,
    key: 'sr-only',
    name: 'Sr Only',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Hides an element on all devices except for screen readers',
    enable: true,
    key: 'sr-only-focusable',
    name: 'Sr Only Focusable',
    type: 'text',
  },
  {
    category: 'Utilities',
    description:
      'Makes an element stay sticky/fixed at the top of the page when you scroll past it',
    enable: true,
    key: 'sticky-top',
    name: 'Sticky Top',
    type: 'text',
  },
  {
    category: 'Utilities',
    description:
      'Added to a link to make its containing block (parent) clickable (works only for parent elements with position:relative)',
    enable: true,
    key: 'stretched-link',
    name: 'Stretched Link',
    type: 'text',
  },
  {
    category: 'Tabs',
    description: 'Used together with .tab-pane to creates toggleable/dynamic tabs/pills',
    enable: true,
    key: 'tab-content',
    name: 'Tab Content',
    type: 'text',
  },
  {
    category: 'Tabs',
    description: 'Used together with .tab-content to creates toggleable/dynamic tabs/pills',
    enable: true,
    key: 'tab-pane',
    name: 'Tab Pane',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Adds basic styling to a table (padding, bottom borders, etc)',
    enable: true,
    key: 'table',
    name: 'Table',
    type: 'text',
  },
  {
    category: 'Tables',
    description:
      'Adds a grey background color to the table row (&lt;tr&gt; or table cell (&lt;td&gt;) (same color used on hover)',
    enable: true,
    key: 'table-active',
    name: 'Table Active',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Adds borders on all sides of the table and cells',
    enable: true,
    key: 'table-bordered',
    name: 'Table Bordered',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Remove borders from a table',
    enable: true,
    key: 'table-borderless',
    name: 'Table Borderless',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Makes a table more compact by cutting cell padding in half',
    enable: true,
    key: 'table-condensed',
    name: 'Table Condensed',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Adds a black background with white text to the table',
    enable: true,
    key: 'table-dark',
    name: 'Table Dark',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Creates a hoverable table (adds a grey background color on table rows on hover)',
    enable: true,
    key: 'table-hover',
    name: 'Table Hover',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Adds zebra-stripes to a table',
    enable: true,
    key: 'table-striped',
    name: 'Table Striped',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Prevents long text from breaking layout',
    enable: true,
    key: 'text-break',
    name: 'Text Break',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Indicates capitalized text',
    enable: true,
    key: 'text-capitalize',
    name: 'Text Capitalize',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Center-aligns text',
    enable: true,
    key: 'text-center',
    name: 'Text Center',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Red text color. Indicates danger',
    enable: true,
    key: 'text-danger',
    name: 'Text Danger',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Dark grey text color',
    enable: true,
    key: 'text-dark',
    name: 'Text Dark',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Removes the underline from a link',
    enable: true,
    key: 'text-decoration-none',
    name: 'Text Decoration None',
    type: 'text',
  },
  {
    category: 'Typography',
    description: "Hides text (helps replace an element's text content with a background image)",
    enable: true,
    key: 'text-hide',
    name: 'Text Hide',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Light-blue text color. Indicates information',
    enable: true,
    key: 'text-info',
    name: 'Text Info',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Light grey text color',
    enable: true,
    key: 'text-light',
    name: 'Text Light',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Indicates justified text',
    enable: true,
    key: 'text-justify',
    name: 'Text Justify',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Aligns the text to the left',
    enable: true,
    key: 'text-left',
    name: 'Text Left',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Changes text to lowercase',
    enable: true,
    key: 'text-lowercase',
    name: 'Text Lowercase',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Grey text color',
    enable: true,
    key: 'text-muted',
    name: 'Text Muted',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Prevents the text from wrapping',
    enable: true,
    key: 'text-nowrap',
    name: 'Text Nowrap',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Blue text color. Indicates something important',
    enable: true,
    key: 'text-primary',
    name: 'Text Primary',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Grey text color. Indicates something &quot;less&quot; important',
    enable: true,
    key: 'text-secondary',
    name: 'Text Secondary',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Resets the color of a text or a link (inherits the color from its parent)',
    enable: true,
    key: 'text-reset',
    name: 'Text Reset',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Aligns text to the right',
    enable: true,
    key: 'text-right',
    name: 'Text Right',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Green text color. Indicates success',
    enable: true,
    key: 'text-success',
    name: 'Text Success',
    type: 'text',
  },
  {
    category: 'Typography',
    description: 'Makes text uppercase',
    enable: true,
    key: 'text-uppercase',
    name: 'Text Uppercase',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'Yellow/orange text color. Indicates warning',
    enable: true,
    key: 'text-warning',
    name: 'Text Warning',
    type: 'text',
  },
  {
    category: 'Colors',
    description: 'White text color',
    enable: true,
    key: 'text-white',
    name: 'Text White',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Adds a black background color to table headers',
    enable: true,
    key: 'thead-dark',
    name: 'Thead Dark',
    type: 'text',
  },
  {
    category: 'Tables',
    description: 'Adds a grey background color to table headers',
    enable: true,
    key: 'thead-light',
    name: 'Thead Light',
    type: 'text',
  },
  {
    category: 'Toast',
    description: 'Creates a toast (alert box that disappears after a few seconds)',
    enable: true,
    key: 'toast',
    name: 'Toast',
    type: 'text',
  },
  {
    category: 'Toast',
    description: 'Toast body',
    enable: true,
    key: 'toast-body',
    name: 'Toast Body',
    type: 'text',
  },
  {
    category: 'Toast',
    description: 'Toast header',
    enable: true,
    key: 'toast-header',
    name: 'Toast Header',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Creates a custom validation message used in validated forms (green text color)',
    enable: true,
    key: 'valid-feedback',
    name: 'Valid Feedback',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Creates a custom validation message used in validated forms (green tooltip)',
    enable: true,
    key: 'valid-tooltip',
    name: 'Valid Tooltip',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Make an element visible',
    enable: true,
    key: 'visible',
    name: 'Visible',
    type: 'text',
  },
  {
    category: 'Forms',
    description: 'Adds validation styles to a form element',
    enable: true,
    key: 'was-validated',
    name: 'Was Validated',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the width of an element to 25%',
    enable: true,
    key: 'w-25',
    name: 'W 25',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the width of an element to 50%',
    enable: true,
    key: 'w-50',
    name: 'W 50',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the width of an element to 75%',
    enable: true,
    key: 'w-75',
    name: 'W 75',
    type: 'text',
  },
  {
    category: 'Utilities',
    description: 'Sets the width of an element to 100%',
    enable: true,
    key: 'w-100',
    name: 'W 100',
    type: 'text',
  },
];

const bootstrap4ClassMap = [];
const bootstrap4ClassArray = [];

for (const property in Bootstrap4Classes) {
  if (Bootstrap4Classes[property].enable) {
    bootstrap4ClassMap.push({
      name: Bootstrap4Classes[property].name,
      value: Bootstrap4Classes[property].key,
    });
    bootstrap4ClassArray.push(Bootstrap4Classes[property].key);
  }
}

export const bootstrap4CSS = {};
bootstrap4CSS.bootstrap4Classes = [...bootstrap4ClassMap];
bootstrap4CSS.bootstrap4ClassesArray = [...bootstrap4ClassArray];
